<template>
  <div class="workorderItem" @click="toDetail(formItem.id)">
    <div class="itemLeft">
      <div class="fault">{{ formItem.sales_feedback }}</div>

      <div class="createtime">
        <div v-if="isEva()">
          <el-rate
            size="small"
            disabled
            :value="formItem.evaluate_num"
          ></el-rate>
        </div>
        {{ formItem.createtime }}
      </div>
    </div>
    <div class="itemRight">
      <div class="status_text">{{ formItem.status_text }}</div>
      <div class="orderno">{{ formItem.ordercode }}</div>
      <div class="status">
        <el-button
          @click="orderBtn()"
          :class="[formItem.status == 5 ? 'orange' : 'blue']"
        >
          {{ formItem.status != 5 ? "联系工程师" : formItem.evaluate_status !=1? "评价":"已评价" }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import Order from "@/components/workorder/index.vue";
export default {
  components: {
    Order,
  },
  props: {
    formItem: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },
  data() {
    return {
      activeName: 'all',
      Show: false,
    };
  },
  created() {
    this.init();
  },
  mounted() {
    
  },
  watch: {
    value: {
      handler: function(newv, oldv) {
      },
      immediate: true,
      deep: true
    },
  },

  methods: {
    init() {},
    isEva() {
      if (this.formItem.evaluate_status == 1 && this.formItem.status == 5) {
        return true;
      } else {
        return false;
      }
    },
    // 操作
    orderBtn() {
      if (this.formItem.evaluate_status ==1) {
        return
      }
      if (this.formItem.status != 5) {
        this.$router.push("/saleRep/afterSales/1");
      } else {
        this.$emit('isShow', this.formItem.id);
      }
    },
    toDetail() {
      
    },
  },
};
</script>


<style scoped lang='scss'>
.workorderItem {
  height: 125px;
  background: rgba(255, 255, 255, 1);
  margin-top: 18px;
  padding: 15px 10px 10px;
  display: flex;
  justify-content: space-between;
  border-radius: 5px;
  .itemLeft {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .fault {
      width: 130px;
      display: -webkit-box !important;
      text-overflow: ellipsis;
      overflow: hidden;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      color: rgba(80, 80, 80, 1);
      font-size: 14px;
      font-weight: bold;
    }
    .createtime {
      font-size: 12px;
      margin-bottom: 4px;
      color: rgba(128, 128, 128, 1);
    }
  }
  .itemRight {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-end;
    .status_text {
      font-size: 14px;
      color: rgba(42, 130, 228, 1);
    }
    .orderno {
      font-size: 12px;
      color: rgba(128, 128, 128, 1);
    }
    .status {
      margin-bottom: 4px;

      .el-button {
        padding-top: 6px;
        width: 100px;
        height: 26px;
        border-radius: 5px;
        color: rgba(255, 255, 255, 1);
      }
    }
  }
}
.blue {
  background: rgba(42, 130, 228, 1);
}
.orange {
  background: rgba(255, 141, 26, 1);
}
</style>
